const IntroTitle = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 438.2 105.65"
    className="work-title"
  >
    <defs></defs>
    <g>
      <path
        className="name-title"
        d="M0.35,0h12.1c5.4,0,8.3,1.15,10.25,2.9c2.3,2.05,3.35,5,3.35,8.65c0,5.7-3.15,8.4-4.8,9.4
		c-2.65,1.6-5.55,1.75-8.4,1.85l-4.4,0.15V36.7h-8.1V0z M8.45,16.8c3.85,0,5.3,0,6.25-0.4c0.65-0.25,2.95-1.35,2.95-5.1
		c0-3.55-1.35-4.3-2.45-4.75c-1.3-0.5-1.9-0.5-6.75-0.5V16.8z"
      />
      <path
        className="name-title"
        d="M36.1,24.9c-0.05,2.7-0.05,7.25,4.85,7.25c2.15,0,3.9-0.4,7.05-1.95l0.75,5.3c-2.7,0.95-4.9,1.75-8.4,1.75
		c-3.25,0-8.6-0.7-10.2-6.8c-0.5-1.95-0.65-5.1-0.65-5.3c0-4.65,0-9,1.8-11.95c2.05-3.4,5.95-3.75,8.1-3.75
		c4.3,0,6.35,1.8,7.65,3.75c1.6,2.35,1.6,4.85,1.6,11.7H36.1z M42.85,20.95c0-4-0.05-7.05-3.55-7.05c-3.3,0-3.25,3.7-3.2,7.05H42.85
		z"
      />
      <path
        className="name-title"
        d="M52.25,10.2h3.95V0.6h6.95v9.6h5.1v5.1h-5.1v13.75c0,0.85,0,2.25,3.5,2.25c0.4,0,0.5,0,1.95-0.15v5.45
		c-2.85,0.35-3.15,0.4-4.2,0.4c-3,0-8.2-0.4-8.2-7.25V15.3h-3.95V10.2z"
      />
      <path
        className="name-title"
        d="M79.05,24.9C79,27.6,79,32.15,83.9,32.15c2.15,0,3.9-0.4,7.05-1.95l0.75,5.3c-2.7,0.95-4.9,1.75-8.4,1.75
		c-3.25,0-8.6-0.7-10.2-6.8c-0.5-1.95-0.65-5.1-0.65-5.3c0-4.65,0-9,1.8-11.95c2.05-3.4,5.95-3.75,8.1-3.75
		c4.3,0,6.35,1.8,7.65,3.75c1.6,2.35,1.6,4.85,1.6,11.7H79.05z M85.8,20.95c0-4-0.05-7.05-3.55-7.05c-3.3,0-3.25,3.7-3.2,7.05H85.8z
		"
      />
      <path
        className="name-title"
        d="M97.3,10.2h6.7v6h0.2c2.5-5.8,5.35-6.6,7.9-6.7v9.15c-2.95,0-4.8,0-7.65,2.4V36.7H97.3V10.2z"
      />
      <path
        className="name-title"
        d="M130.8,0h8.15v13.9h10.3V0h8.25v36.7h-8.1V20.85H139V36.7h-8.2V0z"
      />
      <path
        className="name-title"
        d="M162.95,13.05c2.25-1.75,4.5-3.5,10.15-3.5c1.85,0,5.8,0.45,7.95,2.6c2,2,2,4,2,5.4v13
		c0,0.15,0.2,1.6,1.55,1.65V37h-2.05c-3.4,0-4.8-2.1-5.45-3.3h-0.2c-0.85,1.1-1.35,1.7-2.45,2.35c-0.35,0.2-2.3,1.35-4.6,1.35
		c-2.8,0-7.1-1.45-7.1-7.55c0-2.45,0.9-6.35,5.7-8.55c2.55-1.15,5.25-1.7,7.6-1.85c0-2.6,0-3.35-0.5-4.05
		c-0.45-0.65-1.55-1.15-2.9-1.15c-3.05,0-4.95,1.65-6.4,2.9L162.95,13.05z M176,23.15c-1.55,0.3-6.6,1.25-6.6,5.8
		c0,1.8,1.1,3.25,2.8,3.25c3.2,0,3.8-3.2,3.8-4.95V23.15z"
      />
      <path className="name-title" d="M189.15,0h7.05v36.7h-7.05V0z" />
      <path className="name-title" d="M202.3,0h7.05v36.7h-7.05V0z" />
      <path
        className="name-title"
        d="M220.9,24.9c-0.05,2.7-0.05,7.25,4.85,7.25c2.15,0,3.9-0.4,7.05-1.95l0.75,5.3c-2.7,0.95-4.9,1.75-8.4,1.75
		c-3.25,0-8.6-0.7-10.2-6.8c-0.5-1.95-0.65-5.1-0.65-5.3c0-4.65,0-9,1.8-11.95c2.05-3.4,5.95-3.75,8.1-3.75
		c4.3,0,6.35,1.8,7.65,3.75c1.6,2.35,1.6,4.85,1.6,11.7H220.9z M227.65,20.95c0-4-0.05-7.05-3.55-7.05c-3.3,0-3.25,3.7-3.2,7.05
		H227.65z"
      />
      <path
        className="name-title"
        d="M242.6,10.2l3.8,13.05h0.4l3.25-13.05h6.85l-6.6,24.55c-2.45,9.05-5.3,10.7-10.75,10.7
		c-1.7,0-2.25-0.1-3.45-0.35v-5.9l2.55,0.3c2.45,0,3.3-1.25,3.65-1.8c0.9-1.35,0.9-2.05,0.9-3.6l-7.55-23.9H242.6z"
      />
      <path d="M0,60h24.65v6.7H8v7.8h11.45v6.7H8.1v8.65h17.7v6.85H0V60z" />
      <path
        d="M51.4,70.2l-7,13l7.55,13.5h-7.4c-1.45-2.75-1.7-3.2-3.75-7.5h-0.25l-0.6,1.35L36.9,96.7h-7.4l7.4-13.45L29.85,70.2h7.35
		l2.65,5.5c0.15,0.25,0.6,1.25,0.7,1.45h0.2c0.1-0.2,0.5-1.25,0.6-1.45l2.7-5.5H51.4z"
      />
      <path
        d="M55.8,69.95h6.5v4.2h0.4c1.5-3.2,3.95-4.75,7.1-4.75c4.5,0,5.8,3.1,6.3,5.15c0.55,2.25,0.55,6.1,0.55,10.1
		c0,5.9,0,7.7-1.3,9.7c-0.95,1.45-2.55,2.6-5.5,2.6c-3.2,0-5.25-1.75-6.65-3.9h-0.35v12.3H55.8V69.95z M62.85,89.45
		c1.15,0.9,2.4,1.95,3.95,1.95c2.8,0,2.8-2.15,2.8-7.1c0-0.9-0.1-5.4-0.2-6.05c-0.35-2.55-1.8-2.65-2.65-2.65
		c-1.75,0-3.05,1-3.9,1.9V89.45z"
      />
      <path d="M82.95,60H90v36.7h-7.05V60z" />
      <path
        d="M106.25,69.4c2.95,0,6.75,0.25,9.1,4.05c1.3,2.15,1.65,5.15,1.65,9.9c0,5.45-0.1,8.55-2.85,11.25
		c-0.9,0.85-2.55,2.5-7.25,2.5c-1.6,0-4.4-0.1-6.1-1.05c-4.45-2.5-4.7-6.85-4.7-13.3C96.1,77.75,96.1,69.4,106.25,69.4z M103.2,85.2
		c0,0.95,0.15,3.4,0.35,4.25c0.55,2.4,2.55,2.4,3.05,2.4c3.35,0,3.35-2.35,3.35-9.5c0-4.15,0-7.65-3.3-7.65
		c-3.45,0-3.45,3.25-3.45,5.3V85.2z"
      />
      <path
        d="M136.35,73.45V60h7.1v36.7h-6.6v-4.3h-0.3c-2.4,4.05-4.7,4.7-7.3,4.7c-4.7,0-6.15-3.75-6.55-6c-0.35-2-0.35-4.5-0.35-6.45
		c0-4.85,0-7.85,0.55-10.3c0.6-2.8,2.6-4.9,6.25-4.9c4.4,0,6.05,2.6,6.95,4H136.35z M136.35,77c-0.6-0.55-2.35-2-4.1-2
		c-2.7,0-2.7,2.6-2.7,7c0,3.3,0,5.2,0.15,6.2c0.35,2.2,1.5,2.7,2.7,2.7c2.05,0,3.3-1.35,3.95-2.05V77z"
      />
      <path d="M157.15,65.8h-6.9v-6h6.9V65.8z M150.25,70.2h6.9v26.5h-6.9V70.2z" />
      <path
        d="M163.35,70.2h6.5v4.9H170c1.55-2.85,4.1-5.45,7.6-5.45c6.7,0,6.7,5.65,6.7,7.65v19.4h-7.05V79.4c0-1.05,0.05-3.6-2.3-3.6
		c-2,0-3.2,1.3-4.55,2.75V96.7h-7.05V70.2z"
      />
      <path
        d="M195,98.55c0.7,0.9,1.85,2.45,4.25,2.45c1.15,0,3.3-0.5,4.1-2.25c0.35-0.8,0.4-1.75,0.4-3.05v-4h-0.25
		c-1.5,2.25-3.75,3.8-7.15,3.8c-3,0-5.1-2.2-5.8-4.05C190,90,190,88.05,190,86.85v-7.4c0-2.55,0-10.15,6.7-10.15
		c2.65,0,4,1.15,4.95,1.95c0.9,0.75,1.5,1.55,2.35,3.1h0.2v-4.5h6.6v22.5c0,5.05-0.05,13.05-11.05,13.05c-6,0-8.45-2.65-9.1-4.25
		L195,98.55z M203.75,77.85c-0.6-0.85-2.65-1.7-3.75-1.7c-1.6,0-2.3,0.85-2.6,1.75c-0.35,1-0.5,3.7-0.5,4.6
		c0,0.95,0.15,4.7,0.5,5.65c0.5,1.4,1.55,1.9,2.6,1.9c1.95,0,3.15-1.3,3.75-1.9V77.85z"
      />
      <path
        d="M231.15,72.35c0-8.4,4.5-13.15,13.05-13.15c2.2,0,5.5,0.45,8.05,2.45c3.3,2.6,3.7,7.1,3.8,10.05H248
		c-0.05-1.8-0.15-5.8-4.15-5.8c-1,0-2.25,0.4-3.05,1.15c-1.3,1.2-1.35,3-1.35,4V85c0,2,0,5.85,4.45,5.85c3.3,0,4.3-2.7,4.3-6.65h8.1
		c-0.05,2.65-0.1,2.95-0.35,4.5c-0.3,1.45-0.8,4.1-3.85,6.55c-2.6,2.1-6.4,2.45-8,2.45c-4.25,0-7.2-1-9.5-3.25
		c-1.5-1.45-3.45-3.55-3.45-11.05V72.35z"
      />
      <path
        d="M268.5,84.9c-0.05,2.7-0.05,7.25,4.85,7.25c2.15,0,3.9-0.4,7.05-1.95l0.75,5.3c-2.7,0.95-4.9,1.75-8.4,1.75
		c-3.25,0-8.6-0.7-10.2-6.8c-0.5-1.95-0.65-5.1-0.65-5.3c0-4.65,0-9,1.8-11.95c2.05-3.4,5.95-3.75,8.1-3.75
		c4.3,0,6.35,1.8,7.65,3.75c1.6,2.35,1.6,4.85,1.6,11.7H268.5z M275.25,80.95c0-4-0.05-7.05-3.55-7.05c-3.3,0-3.25,3.7-3.2,7.05
		H275.25z"
      />
      <path d="M287.3,60h7.05v36.7h-7.05V60z" />
      <path d="M300.45,60h7.05v36.7h-7.05V60z" />
      <path d="M313.15,89.05h7.75v8.4l-4.05,8.2h-3.7l3.4-8.95h-3.4V89.05z" />
      <path d="M334.75,90.8h7.1V65.9h-7.65V60h15v30.8h6.75v5.9h-21.2V90.8z" />
      <path
        d="M366,97.4c7.35-7.2,10.15-14.85,10.45-16.2c-1.15,0.9-3.2,1.8-6.15,1.8c-0.4,0-4.45-0.1-7.45-3.35c-1.9-2.05-3-5.3-3-8.15
		c0-8.25,4.9-12.55,11.8-12.55c5.65,0,8.65,3.1,9.6,4.3c1.95,2.4,3.05,5.65,3.05,10.9c0,0.65-0.2,4-0.95,7.15
		c-1.15,4.45-3.9,10.6-7.75,16.1H366z M367.45,71.35c0,1.65,0,5.95,4.55,5.95c3.5,0,4.6-2.55,4.6-6.45c0-2.45-0.55-6.25-4.5-6.25
		C367.45,64.6,367.45,69.6,367.45,71.35z"
      />
      <path
        d="M393.05,97.4c7.35-7.2,10.15-14.85,10.45-16.2c-1.15,0.9-3.2,1.8-6.15,1.8c-0.4,0-4.45-0.1-7.45-3.35
		c-1.9-2.05-3-5.3-3-8.15c0-8.25,4.9-12.55,11.8-12.55c5.65,0,8.65,3.1,9.6,4.3c1.95,2.4,3.05,5.65,3.05,10.9
		c0,0.65-0.2,4-0.95,7.15c-1.15,4.45-3.9,10.6-7.75,16.1H393.05z M394.5,71.35c0,1.65,0,5.95,4.55,5.95c3.5,0,4.6-2.55,4.6-6.45
		c0-2.45-0.55-6.25-4.5-6.25C394.5,64.6,394.5,69.6,394.5,71.35z"
      />
      <path
        d="M432.05,59.5c-2.45,2.45-5.3,5.9-6.95,8.8c-0.95,1.55-3.05,5.35-3.5,7.45c2.35-1.8,5.3-1.8,5.75-1.8
		c5.6,0,10.85,4.2,10.85,11.95c0,2.9-1,12-11.8,12c-8.1,0-12.6-5.55-12.6-14.15c0-5.8,1.05-9.45,3.05-14.15
		c1.6-3.75,1.8-4.05,5.6-10.1H432.05z M430.6,85.25c0-1.15-0.1-2.65-0.9-3.85c-1.05-1.55-2.6-1.75-3.65-1.75
		c-4.55,0-4.55,4.6-4.55,6.55c0,3.05,0.85,6.15,4.45,6.15C430.6,92.35,430.6,87.7,430.6,85.25z"
      />
    </g>
  </svg>
);

export default IntroTitle;
